import { NgModule } from '@angular/core'
import { DisplayAcreagePipe } from './display-acreage.pipe'

@NgModule({
    declarations: [DisplayAcreagePipe],
    exports: [DisplayAcreagePipe],
    providers: [DisplayAcreagePipe],
})
export class DisplayAcreagePipeModule {

}